var map = {
	"./bg/main.yml": 38,
	"./br/main.yml": 39,
	"./ca/main.yml": 40,
	"./de/main.yml": 41,
	"./en/main.yml": 42,
	"./es/main.yml": 43,
	"./fr/main.yml": 44,
	"./gl/main.yml": 45,
	"./he/main.yml": 46,
	"./hr/main.yml": 47,
	"./it/main.yml": 48,
	"./oc/main.yml": 49,
	"./pt_BR/main.yml": 50,
	"./sv/main.yml": 51,
	"./tr/main.yml": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 179;